<template>
  <div class="my-level" :class="[packageName]">
    <div class="level-bg-box">
      <div class="level-bg" :style="{ 'background-image': `url(${backgroundStyle(hostData.curGrade)})` }"></div>
      <div class="level-box">
        <!-- 等级背景 -->
        <div class="level-text">{{ $t('lang.BaseCommon.k002') }}.{{ hostData.curGrade || 0 }}</div>
        <!-- 徽章 -->
        <!-- this.$client.getAppInfo().language == 'ar'  -->
        <div class="level-img" :style="{ 'background-image': `url(${badgeStyle(hostData.curGrade)})` }">{{ hostData.curGrade || 0 }}</div>
        <div class="progress-box">
          <div class="progress-level text">
            <span>{{ $t('lang.BaseCommon.k001') }}.{{ hostData.curWeekGrade }}({{ $t('lang.BaseCommon.k034') }})</span>
            <span>{{ $t('lang.BaseCommon.k001') }}.{{ hostData.curWeekGrade < 10 ? hostData.curWeekGrade + 1 : hostData.curWeekGrade }}</span>
          </div>
          <!-- 进度条 -->
          <div class="progress-line">
            <van-progress class="progress-bar" track-color="#ebebeb" :show-pivot="false" :percentage="percentageVal" stroke-width="11" />
          </div>

          <div class="progress-tips text">
            <span class="beans">
              {{ curGradeData.weekMinIncome > 0 ? curGradeData.weekMinIncome : 0 }}
              <img class="beans-img" :src="getMatchImg('beans')" alt="" />
            </span>
            <span class="beans-tip">
              {{ $t('lang.BaseCommon.k040') }} {{ nextGradeData.weekMinIncome - hostData.curWeekIncomeAmount > 0 ? nextGradeData.weekMinIncome - hostData.curWeekIncomeAmount : 0 }}
              <img class="beans-img" :src="getMatchImg('beans')" alt="" />
              <span class="get-bean">{{ $t('lang.BaseCommon.k049') }}</span>
            </span>
            <div class="beans">
              {{ hostData.curGrade < 10 ? nextGradeData.weekMinIncome : 0 }}
              <img class="beans-img" :src="getMatchImg('beans')" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="call-income" @click="openPrivateDia">
      <div class="title">{{ $t('lang.HostessCenter.k017') }}</div>
      <div class="income">
        <div class="income-num-img">
          {{ myPrivateCallIncome }}
          <img :src="getMatchImg('beans')" alt="" />
          /{{ $t('lang.BaseCommon.k045') }}
        </div>
        <van-icon class="edit" name="edit" />
      </div>
    </div>
    <div class="week-data">
      <div class="last-week week">
        <span>{{ $t('lang.BaseCommon.k002') }}.{{ hostData.lastWeekGrade }}</span>
        <span class="beans">
          {{ hostData.lastWeekIncomeAmount }}
          <img :src="getMatchImg('beans')" alt="" />
        </span>
        <span>{{ $t('lang.HostessCenter.k012') }}</span>
      </div>
      <span class="line"></span>
      <div class="this-week week">
        <span>{{ $t('lang.BaseCommon.k002') }}.{{ hostData.curWeekGrade }}</span>
        <span class="beans">
          {{ hostData.curWeekIncomeAmount }}
          <img :src="getMatchImg('beans')" alt="" />
        </span>
        <span>{{ $t('lang.BaseCommon.k034') }}</span>
      </div>
    </div>
    <div class="content">
      <div class="box-title">{{ $t('lang.BaseCommon.k047') }}</div>

      <!-- 等级选择 -->
      <div class="level-number" ref="scrollLevelList">
        <div v-for="(item, index) in hostData.levels" :key="item.index" @click="handleLevel(item, index)" :class="level === item.grade ? 'active' : ''" :ref="'item' + index">
          {{ $t('lang.BaseCommon.k002') }}.{{ item.grade }}
        </div>
      </div>
      <!-- 等级权益 -->
      <div class="level-right-box">
        <div class="level-right" v-for="(item, index) in newPrivileges" :key="index">
          <div class="right-item">
            <!-- 需要有颜色的变化 -->
            <div class="right-img" :style="{ background: getPrivilegeColors(level, item) }">
              <img :src="item.icon | imgPath" alt="" />
            </div>
            <div class="right-text">
              <div class="tit">
                {{ item.title }}
              </div>
              <div class="con">
                {{ item.content }}
              </div>
            </div>
          </div>
          <div class="right-desc">
            <!-- prettier-ignore -->
            <div v-if="obj.grade >= map.get(String(item.privilegeType))">
              <div class="right-desc-val" v-if="item.privilegeType == 1">
                {{ obj.incomePerMinute }}<img class="icon" :src="getMatchImg('beans')" alt="" />/{{ $t('lang.BaseCommon.k045') }}
              </div>
              <div class="right-desc-val" v-if="item.privilegeType == 4">
                <img class="icon2" src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/iphone.png" alt="" />{{ obj.privateVideoMatchCount }}/{{ $t('lang.BaseCommon.k093') }}
              </div>
              <div class="right-desc-val" v-if="item.privilegeType == 6">
                {{ obj.videoPassIncomeAmount }}<img class="icon" :src="getMatchImg('beans')" alt="" />/{{ hostData.videoPassServerTimeSeconds }}s
              </div>
              <div class="right-desc-val" v-if="item.privilegeType == 8">
                <img class="icon2" src="@/assets/packageAssets/views/P1_Girls/HostessCenter/default/person.png" alt="" />{{ obj.msgLimitDay }}
              </div>
            </div>
            <div class="unlock" v-else>
              <!-- prettier-ignore -->
              <span v-if="map.get(String(item.privilegeType))">
                {{ $t('lang.BaseCommon.k002') }}.{{ map.get(String(item.privilegeType)) }}
              </span>
              <span>{{ $t('lang.HostessCenter.k021') }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 规则 -->
      <div class="box-title">{{ $t('lang.BaseCommon.k044') }}</div>
      <div class="rule-tit">
        {{ $t('lang.HostessCenter.k009') }}
      </div>
      <table class="table-box">
        <tr class="header">
          <th>{{ $t('lang.BaseCommon.k043') }}</th>
          <th>{{ $t('lang.BaseCommon.k083') }}</th>
        </tr>
        <tr class="td-item" v-for="item in hostData.levels" :key="item.grade">
          <td>{{ $t('lang.BaseCommon.k002') }}.{{ item.grade }}</td>
          <td>
            {{ item.weekMinIncome > 0 ? item.weekMinIncome : 0 }}
            <img :src="getMatchImg('beans')" alt="" />
          </td>
        </tr>
      </table>
    </div>

    <!-- 选择 My Private Call income -->
    <Selete :defaultIndex="defaultIndex" :columns="gradeRrr" :showPop="showPri" @currentChoose="currentChoose" />
  </div>
</template>

<script>
import Selete from '@/components/CSelete/Selete.vue'
import { mixin } from '../mixin/index.js'
import { apiFetchHostGradeInfo, apiFetchIncomeGradeList, apiFetchChoosePrivilege } from '@/api/imee'
export default {
  mixins: [mixin],
  components: { Selete },
  data() {
    return {
      showPri: false,
      showImg: false,
      level: 0,
      hostData: {},
      newPrivileges: [],
      newLevels: [],

      obj: {
        incomePerMinute: 0,
        matchCount: 0,
        payerPayAmount: 0,
        privateVideoMatchCount: 0,
        // scanTwitter: false,
        sendMsgToUserCount: 0,
        videoPassIncomeAmount: 0,
        weekMinIncome: 0
      },
      // 当前等级的数据
      curGradeData: {},
      // 下一等级的数据
      nextGradeData: {},
      //每个特权 固定好的 对应相应解锁的等级  循环等级 对于的字段大于0就是解锁了
      map: new Map(),

      gradeIncomeInfo: {},
      gradeRrr: [],
      myPrivateCallIncome: 0,

      showBananaValue: 0, //显示第几张
      defaultIndex: 0
    }
  },
  created() {
    this.fetchHostGradeInfo()
    this.editPrivate()
  },
  mounted() {},
  methods: {
    // 等级背景图
    backgroundStyle(lv) {
      if (lv == 0) {
        return this.levelBgList[1]
      }
      if (lv > 0 && lv <= 3) {
        return this.levelBgList[2]
      }
      if (lv > 3 && lv <= 6) {
        return this.levelBgList[3]
      }
      if (lv > 6 && lv <= 10) {
        return this.levelBgList[4]
      }
    },
    // 等级徽章
    badgeStyle(lv) {
      if (lv == 0) {
        return this.levelBadgeList[1]
      }
      if (lv > 0 && lv <= 3) {
        return this.levelBadgeList[2]
      }
      if (lv > 3 && lv <= 6) {
        return this.levelBadgeList[3]
      }
      if (lv > 6 && lv <= 10) {
        return this.levelBadgeList[4]
      }
    },

    // 选择等级
    handleLevel(item, index) {
      this.level = item.grade
      this.newPrivileges = item.myArr
      this.obj = { ...item }
    },
    closePri() {
      this.showImg = false
    },

    // 打开选择 My Private Call income
    openPrivateDia() {
      this.showPri = true
    },
    // 确定选择
    currentChoose(val) {
      if (this.gradeIncomeInfo.curGrade >= val.id) {
        this.fetchChoosePrivilege(val.id, val.text)
      }
      //
      else {
        const tips = this.$t('lang.HostessCenter.k001')
        this.$client.showToast(tips)
      }
    },
    closeSeletePop() {
      this.showPri = false
    },

    // 获取主播数据
    fetchHostGradeInfo() {
      this.$parent.checkTimeFlag()
      apiFetchHostGradeInfo().then((res) => {
        if (res) {
          this.level = res.curGrade
          if (res.levels.length > 0) {
            res.levels.forEach((item, index) => {
              // 特权1
              if (item.incomePerMinute != null && item.incomePerMinute > 0) {
                if (!this.map.has('1')) {
                  this.map.set('1', index)
                }
              }
              // 特权2
              if (item.sendMsgToUserCount != null && item.sendMsgToUserCount > 0) {
                if (!this.map.has('2')) {
                  this.map.set('2', index)
                }
              }
              // 特权3
              if (item.matchCount != null && item.matchCount > 0) {
                if (!this.map.has('3')) {
                  this.map.set('3', index)
                }
              }
              // 特权5
              if (item.payerPayAmount != null && item.payerPayAmount > 0) {
                if (!this.map.has('5')) {
                  this.map.set('5', index)
                }
              }
              // 特权4
              if (item.privateVideoMatchCount != null && item.privateVideoMatchCount > 0) {
                if (!this.map.has('4')) {
                  this.map.set('4', index)
                }
              }
              // 特权6
              if (item.videoPassIncomeAmount != null && item.videoPassIncomeAmount > 0) {
                if (!this.map.has('6')) {
                  this.map.set('6', index)
                }
              }
              // 特权7
              if (item.scanTwitter != null && item.scanTwitter > 0) {
                if (!this.map.has('7')) {
                  this.map.set('7', index)
                }
              }
              // 特权8
              if (item.msgLimitDay != null && item.msgLimitDay > 0) {
                if (!this.map.has('8')) {
                  this.map.set('8', index)
                }
              }

              item['myArr'] = res.privileges
              // 获取当前周等级数据
              if (res.curWeekGrade == item.grade) {
                this.newPrivileges = item.myArr
                this.curGradeData = item
                this.obj = { ...item }
              }

              // 获取当前周下一等级的数据
              if (res.curWeekGrade + 1 == item.grade) {
                this.nextGradeData = item
              }
            })
          }
          this.hostData = res
          this.$emit('hostessData', this.hostData)
        }
        this.$nextTick(() => {
          this.scrollToIndex(res.curGrade)
        })
      })
    },

    // 滚动到指定位置 <取不到dom的话 这个方法会报错>
    scrollToIndex(index) {
      const element = this.$refs['item' + index]
      if (element && element.length) {
        element[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      }
    },

    // 获取选择的等级
    editPrivate() {
      const that = this
      apiFetchIncomeGradeList().then((res) => {
        if (res) {
          this.defaultIndex = res.incomeGrade
          res.gradeIncomeCfg.forEach((item) => {
            // 先取一个income
            if (item.grade == res.incomeGrade) {
              this.myPrivateCallIncome = item.incomePerMinute
              this.$emit('hostessIncome', this.myPrivateCallIncome)
            }
            // 处理数据
            let url1 = that.getMatchImg('beans')
            let url2 = that.getMatchImg('beans-off')
            let url3 = require(`@/assets/packageAssets/views/P1_Girls/HostessCenter/default/black_unlock.png`)
            item['img1'] = `<img src=${url1} width="24" height="20" style="position:relative;top:3px;padding:0 2px">`
            item['img2'] = `<img src=${url2} width="24" height="20" style="position:relative;top:3px;padding:0 2px">`
            item['img3'] = `<img src=${url3} width="18"  style="position:relative;top:2px;padding:0 2px">`

            let obj = {}
            obj['id'] = item.grade
            if (item.grade > res.curGrade) {
              obj['text'] = item.incomePerMinute + item.img2 + '/min(' + this.$t('lang.BaseCommon.k002') + '.' + item.grade + ')' + item.img3
            } else {
              obj['text'] = item.incomePerMinute + item.img1 + '/min(' + this.$t('lang.BaseCommon.k002') + '.' + item.grade + ')'
            }
            this.gradeRrr.push(obj)
          })
          this.gradeIncomeInfo = res
        }
      })
    },

    fetchChoosePrivilege(grade, text) {
      apiFetchChoosePrivilege(grade).then((res) => {
        if (res.status == 200) {
          this.showPri = false
          this.myPrivateCallIncome = text.substring(0, text.indexOf('<img'))
        }
      })
    },

    // 特权图标背景色会根据等级变化
    getPrivilegeColors(level, item) {
      const mapType = this.map.get(String(item.privilegeType))
      if (level < mapType) {
        return 'linear-gradient(90deg, #ececec 0%, #d9d9d9 100%)'
      }
      if (level < 1 && mapType < 1) {
        return 'linear-gradient(90deg, #C3A4F8 0%, #CB83F2 100%)'
      }
      if (level <= 3 && mapType < 3) {
        return 'linear-gradient(90deg, #B9D8F6 0%, #A3B1FB 100%)'
      }
      if (level <= 6 && mapType < 6) {
        return 'linear-gradient(90deg, #C3A4F8 0%, #CB83F2 100%)'
      }
      if (level <= 10 && mapType < 10) {
        return 'linear-gradient(90deg, #FFCAC2 0%, #FDA0AA 100%)'
      }
    }
  },
  computed: {
    // 进度条值
    percentageVal() {
      if (this.curGradeData.grade == 10) {
        return 100
      } else {
        if (this.nextGradeData) {
          let a = this.hostData.curWeekIncomeAmount
          let b = this.nextGradeData.weekMinIncome
          return (a / b) * 100 > 0 ? (a / b) * 100 : 0
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.my-level {
  .level-bg-box {
    position: relative;
    width: 327px;
    min-height: 157px;
    margin: 20px auto 0;
    padding: 32px 20px 10px;
  }
  .level-bg {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('~@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_off.png') no-repeat;
    background-size: 100% 100%;
  }
  .level-box {
    position: relative;
    z-index: 10;
    width: 100%;
    .level-img {
      width: 110px;
      height: 110px;
      background: url('~@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -45px;
      right: -20px;
      font-family: 'Inter-Regular';
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      line-height: 110px;
      text-align: center;
    }
    .level-text {
      width: 75px;
      height: 44px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 36px;
      color: #3c2913;
      line-height: 44px;
    }
    .progress-box {
      width: 100%;
      margin-top: 25px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 11px;
      color: #947641;
      .beans {
        display: block;
        display: flex;
        align-items: center;
        .beans-img {
          margin: 0 2px;
        }
      }
      .beans-img {
        width: 11px;
        height: 11px;
      }
      .beans-tip {
        display: block;
        text-align: center;
        padding: 0 5px;
        > img {
          position: relative;
          top: -1px;
          vertical-align: middle;
        }
      }
      .get-bean {
        margin: 0 3px;
      }
      .text {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }
      .progress-line {
        position: relative;
        width: 100%;
        height: 8px !important;
        margin: 4px auto 6px;
        .progress-bar {
          height: 8px !important;
          border-radius: 20px;
          ::v-deep .van-progress__portion {
            background: linear-gradient(90deg, #e2cca6 0%, #b29360 100%) !important;
          }
        }
      }
    }
  }
  .call-income {
    width: 327px;
    height: 56px;
    padding: 17px 12px 0;
    margin: -17px auto 0;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    border-radius: 0 0 10px 10px;
    .title {
      color: #333333;
    }
    .income {
      display: flex;
      align-items: center;
      color: #925dff;
      .income-num-img {
        display: flex;
        align-items: center;
        margin: 0 5px;
        > img {
          width: 11px;
          margin: 0 1px;
        }
      }
      .edit {
        font-size: 16px;
      }
    }
  }
  .week-data {
    position: relative;
    width: 327px;
    margin: 10px auto 30px;
    padding: 10px 0;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .week {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
      width: 36px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      font-size: 17px;
      color: #3c2913;
      .beans {
        display: flex;
        align-items: center;
        margin: 4px 0 6px 0;
        > img {
          width: 16px;
          height: 16px;
          margin: 0 1px;
        }
      }
      > span:nth-child(3) {
        color: #999999;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
      }
    }
    .line {
      height: 36px;
      width: 1px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%);
      background: #f0f0f0;
    }
  }
  .content {
    width: 100%;
    font-family: 'Inter-Regular';
    padding: 0 16px;
    .box-title {
      margin: 30px 8px 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      font-size: 14px;
    }
    .level-number {
      width: 328px;
      height: 24px;
      margin: 16px auto 10px;
      overflow-x: auto;
      white-space: nowrap;
      > div {
        display: inline-block;
        height: 20px;
        padding: 0 5px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        text-align: center;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;
      .active {
        position: relative;
        color: #925dff;
        font-weight: 600;
        font-size: 17px;
      }
      .active::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        width: 27px;
        height: 2px;
        background-color: #d7c7fc;
        border-radius: 2px;
      }
    }
    .level-right-box {
      width: 343px;
      min-height: 92px;
      padding: 10px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 12px;
    }
    .level-right {
      font-family: 'Inter-Regular';
      display: flex;
      justify-content: space-between;
      padding: 16px 0;
      border-bottom: 1px solid #f9f9fb;
      .right-item {
        display: flex;
      }
      .right-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border: 1px solid #ffffff;
        border-radius: 50%;
        > img {
          width: 24px;
          height: 24px;
        }
      }
      .right-text {
        width: 176px;
        margin: 0 8px;
        .tit {
          // height: 17px;
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 17px;
          color: #333333;
          font-weight: 500;
        }
        .con {
          line-height: 15px;
          font-size: 12px;
          color: #999999;
          font-weight: 400;
          white-space: wrap;
        }
      }
      .right-desc {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        color: #925dff;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        .right-desc-val {
          display: flex;
          align-items: center;
          .icon {
            width: 14px;
            margin: 0 1px;
          }
        }
        .icon {
          width: 18px;
        }
        .icon2 {
          width: 12px;
          margin: 0 3px;
        }
        .unlock {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #000;
          line-height: 20px;
          > span:nth-child(2) {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .level-right:last-child {
      border-bottom: none;
    }

    // 规则
    .rule-tit {
      width: 343px;
      padding: 8px 12px;
      margin: 0 auto;
      background: #ededf3;
      border-radius: 6px;
      font-weight: 400;
      font-size: 11px;
      color: #333333;
      line-height: 18px;
    }
    .table-box {
      margin: 0 auto;
      margin-top: 10px;
      font-family: 'Inter-Regular';
      font-size: 14px;
      border-radius: 2px;
      .header {
        font-size: 15px;
        color: #333333;
      }
      th {
        height: 36px;
        font-weight: 700;
        text-align: center;
        border: 1px solid #e9e9e9;
        background-color: #f1f1f6;
      }
      td {
        height: 36px;
        text-align: center;
        border: 1px solid #e9e9e9;
        > img {
          width: 16px;
        }
      }
      td:nth-child(1) {
        width: 114px;
        color: #999999;
      }
      td:nth-child(2) {
        width: 230px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 14px;
          margin: 0 2px;
        }
      }
      .td-item {
        background-color: #fff;
      }
      .td-item:nth-child(odd) {
        background-color: #fafbfd;
      }
    }
  }
  .wrapper {
    display: flex;
    justify-content: center;
    width: 315px;
    height: 312px;
    padding: 20px 20px 10px;
    background-color: #fff;
    border-radius: 20px;
    font-family: 'Inter-Regular';
    text-align: center;
    .wrapper-title {
      margin: 20px 0 12px;
      text-align: center;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
    }
    .wrapper-content {
      display: inline-block;
      font-size: 15px;
      color: #999999;
      line-height: 22px;
      text-align: left;
    }
    ::v-deep .van-swipe__indicator--active {
      background-color: #a338fc !important;
    }
  }

  .van-swipe-item {
    width: 275px !important;
    height: 160px !important;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.my-level.kiko {
  .level-bg-box {
    position: relative;
    width: 327px;
    min-height: 157px;
    margin: 20px auto 0;
    padding: 32px 20px 10px;
  }
  .level-bg {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('~@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg_off.png') no-repeat;
    background-size: 100% 100%;
  }
  .level-box {
    position: relative;
    z-index: 10;
    width: 100%;
    .level-img {
      width: 110px;
      height: 110px;
      background: url('~@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_off.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -45px;
      right: -20px;
      font-family: 'Inter-Regular';
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      line-height: 110px;
      text-align: center;
    }
    .level-text {
      width: 75px;
      height: 44px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 36px;
      color: #3c2913;
      line-height: 44px;
    }
    .progress-box {
      width: 100%;
      margin-top: 25px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 11px;
      color: #947641;
      .beans {
        display: block;
        display: flex;
        align-items: center;
        .beans-img {
          margin: 0 2px;
        }
      }
      .beans-img {
        width: 11px;
        height: 11px;
      }
      .beans-tip {
        display: block;
        text-align: center;
        padding: 0 5px;
        > img {
          position: relative;
          top: -1px;
          vertical-align: middle;
        }
      }
      .get-bean {
        margin: 0 3px;
      }
      .text {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }
      .progress-line {
        position: relative;
        width: 100%;
        height: 8px !important;
        margin: 4px auto 6px;
        .progress-bar {
          height: 8px !important;
          border-radius: 20px;
          ::v-deep .van-progress__portion {
            background: linear-gradient(90deg, #e2cca6 0%, #b29360 100%) !important;
          }
        }
      }
    }
  }
  .call-income {
    width: 327px;
    height: 56px;
    padding: 17px 12px 0;
    margin: -17px auto 0;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    border-radius: 0 0 10px 10px;
    .title {
      color: #333333;
    }
    .income {
      display: flex;
      align-items: center;
      color: #b79b21;
      .income-num-img {
        display: flex;
        align-items: center;
        margin: 0 5px;
        > img {
          width: 14px;
        }
      }
      .edit {
        font-size: 16px;
      }
    }
  }
  .week-data {
    position: relative;
    width: 327px;
    margin: 10px auto 30px;
    padding: 10px 0;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .week {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
      width: 36px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      font-size: 17px;
      color: #3c2913;
      .beans {
        display: flex;
        align-items: center;
        margin: 4px 0 6px 0;
        > img {
          width: 16px;
          height: 16px;
          margin: 0 1px;
        }
      }
      > span:nth-child(3) {
        color: #b2b2b2;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
      }
    }
    .line {
      height: 36px;
      width: 1px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%);
      background: #f0f0f0;
    }
  }
  .content {
    width: 100%;
    font-family: 'Inter-Regular';
    padding: 0 16px;
    .box-title {
      margin: 30px 8px 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      font-size: 14px;
    }
    .level-number {
      width: 328px;
      height: 24px;
      margin: 16px auto 10px;
      overflow-x: auto;
      white-space: nowrap;
      > div {
        display: inline-block;
        height: 20px;
        padding: 0 5px;
        font-weight: 400;
        font-size: 14px;
        color: #b2b2b2;
        line-height: 20px;
        text-align: center;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;
      .active {
        position: relative;
        color: #333333;
        font-weight: 600;
        font-size: 17px;
      }
      .active::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        width: 27px;
        height: 2px;
        background-color: #333333;
        border-radius: 2px;
      }
    }
    .level-right-box {
      width: 343px;
      min-height: 92px;
      padding: 10px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 12px;
    }
    .level-right {
      font-family: 'Inter-Regular';
      display: flex;
      justify-content: space-between;
      padding: 16px 0;
      border-bottom: 1px solid #f9f9fb;
      .right-item {
        display: flex;
      }
      .right-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border: 1px solid #ffffff;
        border-radius: 50%;
        > img {
          width: 24px;
          height: 24px;
        }
      }
      .right-text {
        width: 176px;
        margin: 0 8px;
        .tit {
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 17px;
          color: #333333;
          font-weight: 500;
        }
        .con {
          line-height: 15px;
          font-size: 12px;
          color: #b2b2b2;
          font-weight: 400;
          white-space: wrap;
        }
      }
      .right-desc {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        color: #b79b21;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        .right-desc-val {
          display: flex;
          align-items: center;
          .icon {
            width: 14px;
            margin: 0 1px;
          }
        }
        .icon {
          width: 14px;
        }
        .icon2 {
          width: 12px;
          margin: 0 3px;
        }
        .unlock {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #000;
          line-height: 20px;
          > span:nth-child(2) {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .level-right:last-child {
      border-bottom: none;
    }

    // 规则
    .rule-tit {
      width: 343px;
      padding: 8px 12px;
      margin: 0 auto;
      background: #ededf3;
      border-radius: 6px;
      font-weight: 400;
      font-size: 11px;
      color: #333333;
      line-height: 18px;
    }
    .table-box {
      margin: 0 auto;
      margin-top: 10px;
      font-family: 'Inter-Regular';
      font-size: 14px;
      border-radius: 2px;
      .header {
        font-size: 15px;
        color: #333333;
      }
      th {
        height: 36px;
        font-weight: 700;
        text-align: center;
        border: 1px solid #e9e9e9;
        background-color: #f1f1f6;
      }
      td {
        height: 36px;
        text-align: center;
        border: 1px solid #e9e9e9;
        > img {
          width: 16px;
        }
      }
      td:nth-child(1) {
        width: 114px;
        color: #b2b2b2;
      }
      td:nth-child(2) {
        width: 230px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 14px;
          margin: 0 2px;
        }
      }
      .td-item {
        background-color: #fff;
      }
      .td-item:nth-child(odd) {
        background-color: #fafbfd;
      }
    }
  }
  .wrapper {
    display: flex;
    justify-content: center;
    width: 315px;
    height: 312px;
    padding: 20px 20px 10px;
    background-color: #fff;
    border-radius: 20px;
    font-family: 'Inter-Regular';
    text-align: center;
    .wrapper-title {
      margin: 20px 0 12px;
      text-align: center;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
    }
    .wrapper-content {
      display: inline-block;
      font-size: 15px;
      color: #b2b2b2;
      line-height: 22px;
      text-align: left;
    }
    ::v-deep .van-swipe__indicator--active {
      background-color: #b79b21 !important;
    }
  }

  .van-swipe-item {
    width: 275px !important;
    height: 160px !important;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .my-level .level-bg-box .level-bg {
    transform: rotateY(180deg) !important;
  }

  .my-level .level-bg-box .level-img {
    right: auto !important;
    left: -20px !important;
  }
}
</style>
